<template>
  <div id="app" class="min-h-screen overflow-x-hidden font-sans antialiased bg-gray-50">
    <router-view :key="account ? account.id : 'none'" />
    <portal-target name="modals" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'App',

    metaInfo: {
      title: 'Fleetbeacon',
      titleTemplate: '%s | Fleetbeacon',
      description: 'Courier Last-Mile Booking & Delivery Software. Reduce costs, boost customer satisfaction and scale your operations efficiently with a suite of tools for local service and delivery fleets.'
    },

    computed: {
      ...mapGetters(['account'])
    },

    async mounted () {
      if (this.$cookies.get('token')) {
        this.$store.dispatch('syncUser')
      }
    }
  }
</script>

<style>
#app {
  font-feature-settings: 'kern' 1, 'liga' 1, 'calt' 1, 'case' 1, 'ccmp' 1, 'dlig' 1, 'ss01' 1, 'ss03' 1, 'cv02' 1, 'cv04' 1, 'cv09' 1;
}
</style>